import Sfp from './sfp';

declare global {
  export type SFPayments = Sfp;
  export const SFPayments: typeof Sfp;
}

(window as any).SFPayments = Sfp;
